import { render, staticRenderFns } from "./comment_component.vue?vue&type=template&id=6f50ef3f&"
import script from "./comment_component.vue?vue&type=script&lang=js&"
export * from "./comment_component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports